import { render, staticRenderFns } from "./kw_tree_label.vue?vue&type=template&id=35b185c0&scoped=true&"
import script from "./kw_tree_label.vue?vue&type=script&lang=js&"
export * from "./kw_tree_label.vue?vue&type=script&lang=js&"
import style0 from "./kw_tree_label.vue?vue&type=style&index=0&id=35b185c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b185c0",
  null
  
)

component.options.__file = "kw_tree_label.vue"
export default component.exports